<template>
  <section class="landscape-tab-products-wrap clearfix">
    <div class="container">
      <div class="tab-products-header clearfix">
        <h5 class="section-title float-left">{{ data.title }}</h5>

        <ul class="tabs float-right">
          <li
            v-for="(tab, index) in tabs"
            :key="index"
            :class="classes(tab)"
            @click="change(tab)"
          >
            {{ String(tab.label).charAt(0).toUpperCase() + String(tab.label).slice(1).toLowerCase() }}
          </li>
        </ul>
      </div>

      <div class="tab-content landscape-right-tab-products">
        <ProductCard
          v-for="product in products" :key="product.id"
          :product="product"
          :isAdmin="isAdmin"
          :target-from-id="'productsTabsTwoCard'"
          :payment_methods="payment_methods"
        />
      </div>
    </div>

    <dynamic-tab
      v-for="(tabLabel, index) in data.tabs"
      :key="index"
      :label="tabLabel"
      :url="route('storefront.tab_products.index', {sectionNumber: 2, tabNumber: index + 1 })"
    >
    </dynamic-tab>
  </section>
</template>

<script>
import ProductCard from "../ProductCard.vue"
import DynamicTabsMixin from "../../mixins/DynamicTabsMixin"

export default {
  components: { ProductCard },

  mixins: [DynamicTabsMixin],

  props: ["data", "isAdmin", "payment_methods"],

  methods: {
    selector() {
      return $(".landscape-right-tab-products")
    },

    slickOptions() {
      return {
        rows: 0,
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        rtl: window.Trillion.rtl,
        responsive: [
          {
            breakpoint: 1550,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 920,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  }
}
</script>
